/**
 * PrintReportHeader - Reusable header for printed reports
 * Shows organization name, address, phone, and report title
 * Only visible when printing (hidden on screen)
 */
import { useAuth } from "@/contexts/AuthContext";

const PrintReportHeader = ({ reportTitle, showDate = true }) => {
  const { organization } = useAuth();

  return (
    <div className="hidden print:block mb-8 print-report-header">
      {/* Logo */}
      <div className="mb-4">
        <img 
          src="/simple-sign-in-logo.png" 
          alt="Simple Sign In" 
          className="h-12 w-auto" 
          onError={(e) => e.target.style.display='none'} 
        />
      </div>
      
      {/* Header Content */}
      <div className="text-center border-b-4 border-brand-primary pb-4 mb-6">
        {/* Organization Name */}
        <h2 className="text-2xl font-semibold text-ink-main mb-1">
          {organization?.name || "Childcare Center"}
        </h2>
        
        {/* Organization Contact Info (if entered in profile) */}
        {(organization?.address || organization?.phone) && (
          <div className="text-sm text-ink-muted mt-1">
            {organization?.address && (
              <p className="whitespace-pre-line">{organization.address}</p>
            )}
            {organization?.phone && (
              <p>{organization.phone}</p>
            )}
          </div>
        )}
        
        {/* Report Title */}
        {reportTitle && (
          <h2 className="text-xl font-semibold text-brand-primary mt-2">
            {reportTitle}
          </h2>
        )}
        
        {/* Generated Date */}
        {showDate && (
          <p className="text-sm text-ink-muted mt-2">
            Generated: {new Date().toLocaleDateString('en-US', { 
              year: 'numeric', 
              month: 'long', 
              day: 'numeric' 
            })}
          </p>
        )}
      </div>
    </div>
  );
};

export default PrintReportHeader;
